
export { useCmsConfig } from "/home/jenkins/agent/workspace/web-sunrise-prod/web-sunrise-grandiaziende-deploy-prod/libs/business/data-access/src/lib/cms/cms.config.ts"